export const Types = {
	IA_SUMMARY_REQUEST: "IA_SUMMARY_REQUEST",
	IA_SUMMARY_SUCCESS: "IA_SUMMARY_SUCCESS",
	IA_SUMMARY_FAILURE: "IA_SUMMARY_FAILURE",
};

export interface IaState {
	summary: any;
	loadingSummary: boolean;
	error: string | null;
}

const INITIAL_STATE: IaState = {
	summary: null,
	loadingSummary: false,
	error: null,
};

export default function ia(
	state: IaState = INITIAL_STATE,
	action: any
): IaState {
	switch (action.type) {
		case Types.IA_SUMMARY_REQUEST:
			return {
				...state,
				loadingSummary: true,
				error: null,
			};
		case Types.IA_SUMMARY_SUCCESS:
			return {
				...state,
				loadingSummary: false,
				summary: action.payload,
			};
		case Types.IA_SUMMARY_FAILURE:
			return {
				...state,
				loadingSummary: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

export const IaActions = {
	ia_summary_request: () => ({
		type: Types.IA_SUMMARY_REQUEST,
	}),
	ia_summary_success: (summary: any) => ({
		type: Types.IA_SUMMARY_SUCCESS,
		payload: summary,
	}),
	ia_summary_failure: (error: string) => ({
		type: Types.IA_SUMMARY_FAILURE,
		payload: error,
	}),
};
